import Label from '../../Label';
import { useSelect } from '../hooks/useCoreContext';

const LabelPart = ({
	label,
	name,
	tooltipId,
	tooltipText,
	children,
	required,
	disabled,
	endAdornment,
	infoCopy,
	inline,
}: {
	label: string;
	name: string;
	tooltipId?: string;
	tooltipText?: string;
	children?: React.ReactNode;
	required?: boolean;
	disabled?: boolean;
	endAdornment?: React.ReactNode;
	infoCopy?: React.ReactNode;
	inline?: boolean;
}) => {
	const { ids } = useSelect();

	return (
		<Label
			label={label}
			name={name}
			tooltipId={tooltipId}
			tooltipText={tooltipText}
			htmlFor={ids.input}
			children={children}
			required={required}
			disabled={disabled}
			endAdornment={endAdornment}
			infoCopy={infoCopy}
			inline={inline}
		/>
	);
};

export default LabelPart;
